export default "import React from 'react';\n\nimport Lozenge from '../../src';\n\nexport default () => <Lozenge isBold>Bold default lozenge</Lozenge>;\n";